import { useKeycloak } from '@react-keycloak/web';
import React, { useEffect } from 'react';

const Logout: React.FC = () => {
	const { keycloak } = useKeycloak();
	useEffect(() => {
		keycloak.logout();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <></>;
};

export default Logout;
